import { render } from "./ChooseMeasureType.vue?vue&type=template&id=1b71c367&scoped=true"
import script from "./ChooseMeasureType.vue?vue&type=script&lang=js"
export * from "./ChooseMeasureType.vue?vue&type=script&lang=js"

import "./ChooseMeasureType.vue?vue&type=style&index=0&id=1b71c367&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\projetos\\orcamento-online-concreto\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b71c367"]])

export default __exports__